import { render, staticRenderFns } from "./Leak.vue?vue&type=template&id=fb187c80&"
import script from "./Leak.vue?vue&type=script&lang=js&"
export * from "./Leak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports